module.exports = __webpack_public_path__ + "img/guide1_pc.f8557bff.jpg";